export const PERMISSION_CODE_MAP = {
  app_management: {
    code: "app_management",
    name: "软件管理",
  },
  complaint_handling: {
    code: "complaint_handling",
    name: "客诉处理",
  },
  data_service: {
    code: "data_service",
    name: "数据服务",
  },
};

export const PERMISSION_ORDER = [
  "app_management",
  "complaint_handling",
  "data_service",
];

export const SUB_ACCOUNT_PERMISSION_ORDER = [
  "app_management",
  "complaint_handling",
];

export const IDENTITY_TYPE_MAP = {
  1: "owner",
  2: "sub_account",
  owner: "owner",
  sub_account: "sub_account",
};

export const IDENTITY_TYPE_NUMBER_MAP = {
  owner: 1,
  sub_account: 2,
  1: 1,
  2: 2,
};

export const SUB_ACCOUNT_STATUS_MAP = {
  active: "active",
  disabled: "disabled",
  removed: "removed",
};

export const PERMISSION_ROUTE_MAP = [
  { pattern: /^\/view\/home$/, code: "app_management" },
  { pattern: /^\/view\/detail\/.+$/, code: "app_management" },
  { pattern: /^\/view\/register\/add$/, code: "app_management" },
  { pattern: /^\/view\/register\/.+$/, code: "app_management" },
  { pattern: /^\/view\/complaint_center$/, code: "complaint_handling" },
  { pattern: /^\/view\/newComplaintDetail\/.+$/, code: "complaint_handling" },
  { pattern: /^\/view\/data_service_redirect$/, code: "data_service" },
];

export const normalizeIdentityType = (identityType) => {
  return IDENTITY_TYPE_MAP[identityType] || "";
};

export const toIdentityTypeNumber = (identityType) => {
  return IDENTITY_TYPE_NUMBER_MAP[identityType] || 0;
};

export const normalizePermissions = (permissions = []) => {
  const normalized = Array.isArray(permissions) ? permissions : [];
  return PERMISSION_ORDER.filter((code) => normalized.includes(code));
};

export const normalizeSubAccountStatus = (status) => {
  return SUB_ACCOUNT_STATUS_MAP[status] || "disabled";
};

export const getPermissionName = (code) => {
  return PERMISSION_CODE_MAP[code]?.name || code;
};

export const getPermissionOptions = (permissionModules = [], { scope } = {}) => {
  const scopeOrder = scope === "sub_account" ? SUB_ACCOUNT_PERMISSION_ORDER : PERMISSION_ORDER;

  if (Array.isArray(permissionModules) && permissionModules.length > 0) {
    return permissionModules
      .filter((item) => scopeOrder.includes(item.code))
      .map((item) => ({
        label: item.name || getPermissionName(item.code),
        value: item.code,
        disabled: Boolean(item.disabled),
      }));
  }

  return scopeOrder.map((code) => ({
    label: getPermissionName(code),
    value: code,
  }));
};

export const getRouteRequiredPermission = (pathname = "") => {
  const target = PERMISSION_ROUTE_MAP.find((item) => item.pattern.test(pathname));
  return target?.code || "";
};

export const canVisitModule = ({ identityType, permissionCodes = [], requiredPermission }) => {
  if (identityType === "owner") return true;
  if (!requiredPermission) return true;
  return normalizePermissions(permissionCodes).includes(requiredPermission);
};

export const resolveHeaderEntries = ({ identityType, identityCount }) => {
  return {
    showPermissionManage: identityType === "owner",
    showMyPermissions: identityType === "sub_account",
    showSwitchIdentity: Number(identityCount) > 1,
  };
};

export const resolveLandingPath = ({ identityType, permissionCodes = [], needSelectIdentity }) => {
  if (needSelectIdentity) return "/view/identity_select";
  if (identityType === "owner") return "/view/home";

  const scopeOrder = identityType === "sub_account" ? SUB_ACCOUNT_PERMISSION_ORDER : PERMISSION_ORDER;
  const normalized = normalizePermissions(permissionCodes).filter((code) => scopeOrder.includes(code));
  if (normalized.length === 0) return "/view/no_access?scene=no_permission";

  if (normalized.includes("app_management")) return "/view/home";
  if (normalized.includes("complaint_handling")) return "/view/complaint_center";
  if (normalized.includes("data_service")) return "/view/data_service_redirect";

  return "/view/home";
};
